
const LocalConfig = {
    BACKEND: 'http://localhost:1337',
    APP: 'http://localhost:3000',
    ENVIRONMENT: 'local',
    INTERCOM_APP_ID: 'fel1xywj',
    PUSHER_APP_ID: '744914',
    PUSHER_KEY: 'b0a5718a802d1abae98d',
    SEGMENT_WRITE_KEY: 'M9F7zzfqUjsjk20eq1Z7W1ALqt5XdCrn', // TODO: Disable segment for local
    SEGMENT_CONFIG: {
        flushAt: 1,
        flushInterval: 1
    }
};

const ProductionConfig = {
    BACKEND: 'https://graphql-proxy.k-production.alvalabs.io',
    APP: 'https://app.alvalabs.io',
    ENVIRONMENT: 'production',
    INTERCOM_APP_ID: 'xjr8vtw1',
    PUSHER_APP_ID: '402008',
    PUSHER_KEY: 'a742082876705ec3a841',
    SEGMENT_WRITE_KEY: 'Mgal7mht1pERcT2wpXPluTxYhLSZnMUB',
    SEGMENT_CONFIG: {
        flushAt: 10,
        flushInterval: 5000
    }
};

const DevConfig = {
    BACKEND: 'https://graphql-proxy.k-staging.alvalabs.io',
    APP: 'https://staging.app.alvalabs.io',
    ENVIRONMENT: 'dev',
    INTERCOM_APP_ID: 'fel1xywj',
    PUSHER_APP_ID: '744909',
    PUSHER_KEY: '7f40d5399d37535d8c99',
    SEGMENT_WRITE_KEY: 'M9F7zzfqUjsjk20eq1Z7W1ALqt5XdCrn',
    SEGMENT_CONFIG: {
        flushAt: 10,
        flushInterval: 5000
    }
};


function isLocal() {
    return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
}

function isDev() {
    return window.location.hostname.includes('staging.app.alvalabs.io');
}

export function getConfig() {
    if (isLocal()) {
        return LocalConfig;
    }
    if (isDev()) {
        return DevConfig;
    }

    return ProductionConfig;
}


export function getBaseUrl() {
    return getConfig().BACKEND;
}

export const graphqlEndpoint = getBaseUrl() + '/graphql';

// Language config
export const DEFAULT_LOCALE = 'sv';
